import Scalar from "src/libs/scalars/scalars/Scalar"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import { VerticalType } from "src/libs/scalars/interface/IScalarForm"
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import { ILandingConsoleStore, useLandingConsoleStore } from "../../data/store"
import { __ } from "src/libs/utilities"
import { LANDING_TYPE_CONTENT, ModalContent } from "../../data/interfaces"
import getMeatsByType from "../../views/utils/getMeatsByType"
import { SelectEnabled } from "src/libs/scalars/scalars/Select"

/* Protopia Ecosystem component */
export interface IOverlayScalarProps extends ICompositeWidgetProps{
   
}
const OverlayScalar = (props: IOverlayScalarProps): JSX.Element => {
    return <>
            <Scalar  
                value={ props.value }
                editable={props.editable }
                subtitle={props.title}
                notClear
                rowClassName="width-auto"
                vertical={ VerticalType.VERTICAL }
                enabledForm={ <OverlayEnabled {...props} /> }  
                desabledForm={ <OverlayDisable {...props} /> }   
                subMenus={props.subMenus}
                onSubMenu={props.onSubmenu}
            />
        </>
}
export default OverlayScalar


export const OverlayEnabled = (props: IOverlayScalarProps): JSX.Element => {
    const modalsOpen: ID[]  = useLandingConsoleStore((state: ILandingConsoleStore) => state.modalsOpen )
    const modals: ID[]      = useLandingConsoleStore((state: ILandingConsoleStore) => state.modals )

    const [value, setValue] = useState<any>( 
        props.value ||props.default || []
    )

    useEffect(() => {
        setValue( props.value )
    }, [ props.value ])

    const allModals: ModalContent[] = getMeatsByType( LANDING_TYPE_CONTENT.MODAL )

    const onChange = ( _value: any, field: string ="", dop: any = {} ) => { 
        if(props.onChange) {
        props.onChange( _value, props.field, "" )
    }  
    }  
    return <div className="w-100 p-3 mr-2 d-flex flex-column flex-wrap"> 
        <div className="descr">
            { __( "Open modal." ) }
        </div>
        <SelectEnabled
            type="select"
            value={ value }
            values={[
                ...allModals.map(modal => {
                    return {
                        _id: modal.id,
                        title: modal.title || modal.id
                    }
                })
            ]}
            editable
            onChange={ onChange }
        />
        <div className="descr pl-5 my-2">
            { __( "Choose enabled modal from exists modal's meats" ) }
        </div>
    </div>
}

export const OverlayDisable = (props: IOverlayScalarProps): JSX.Element => {
    return <></>
}